import React from 'react';
import './SectionIntro.css';

function SectionIntro({ kicker, kickerTone, title, children, headingId }) {
  return (
    <div className="ayro-section__copy">
      <p className={`ayro-kicker${kickerTone ? ` ayro-kicker--${kickerTone}` : ''}`}>{kicker}</p>
      <h2 id={headingId}>{title}</h2>
      <p>{children}</p>
    </div>
  );
}

export default SectionIntro;
